/*
  Eventzauber - Modus-Umschaltung (Mieten / Kaufen)

  Zustaendig ausschliesslich fuer den MENUE-Zustand. Es werden niemals Inhalte
  ausgetauscht und niemals Weiterleitungen ausgeloest.

  Oeffentliche Schnittstelle fuer Dritt-Integrationen (z. B. Produkt-Konfigurator):
    - Attribut  document.documentElement.dataset.ezModus  ('miete' | 'kauf')
    - Speicher  localStorage.ez_modus
    - Event     document.addEventListener('ez:modus-changed', e => e.detail.modus)

  ----------------------------------------------------------------------------
  WICHTIG - warum der Drawer eine Sonderbehandlung braucht:

  Impacts Drawer loest die Untermenues ueber data-panel="1-0", "1-1" usw. auf
  und sucht das passende Panel im GESAMTEN Drawer. Haengen dort beide
  Menue-Varianten gleichzeitig, findet er immer die erste (Miete) - im
  Kauf-Menue liessen sich Untermenues dann nicht mehr oeffnen.

  Deshalb: Es befindet sich immer nur EINE Variante im Drawer. Die inaktive
  wird ausserhalb geparkt und beim Umschalten zurueckgetauscht. Auf dem Desktop
  ist das nicht noetig, dort reicht die CSS-Sichtbarkeit.
  ----------------------------------------------------------------------------
*/
(function () {
  'use strict';

  var KEY = 'ez_modus';
  var DRAWER_ID = 'header-sidebar-menu';
  var LEAVE_MS = 160;
  var ENTER_MS = 420;
  var root = document.documentElement;
  var parkplatz = null;

  var reduceMotion = window.matchMedia
    && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function isValid(modus) {
    return modus === 'miete' || modus === 'kauf';
  }

  function remember(modus) {
    try {
      localStorage.setItem(KEY, modus);
    } catch (e) {
      /* Privater Modus o. ae. - der Seiten-Modus funktioniert weiterhin */
    }
  }

  function getParkplatz() {
    if (!parkplatz) {
      parkplatz = document.createElement('div');
      parkplatz.hidden = true;
      parkplatz.setAttribute('data-ez-parkplatz', '');
      document.body.appendChild(parkplatz);
    }
    return parkplatz;
  }

  /* Genau eine Menue-Variante im Drawer lassen und den Toggle ans Ende setzen. */
  function syncDrawer(modus) {
    var drawer = document.getElementById(DRAWER_ID);
    if (!drawer) return;

    var park = getParkplatz();

    var gesucht = park.querySelector('[data-ez-menu="' + modus + '"]');
    if (gesucht) drawer.appendChild(gesucht);

    Array.prototype.slice.call(drawer.children).forEach(function (kind) {
      if (kind.nodeType !== 1 || !kind.hasAttribute('data-ez-menu')) return;
      if (kind.getAttribute('data-ez-menu') !== modus) park.appendChild(kind);
    });

    var aktiv = drawer.querySelector('[data-ez-menu="' + modus + '"]');
    if (!aktiv) return;

    var toggle = aktiv.querySelector('.ez-toggle');
    if (toggle && toggle !== aktiv.lastElementChild) aktiv.appendChild(toggle);
  }

  function announce(modus) {
    document.dispatchEvent(new CustomEvent('ez:modus-changed', { detail: { modus: modus } }));
  }

  function applyModus(modus) {
    root.setAttribute('data-ez-modus', modus);
    remember(modus);
    syncDrawer(modus);
    announce(modus);
  }

  /* Menuewechsel an Ort und Stelle - kein Seitenwechsel, kein Nachladen. */
  function switchInPlace(modus) {
    if (!isValid(modus)) return;
    if (root.getAttribute('data-ez-modus') === modus) return;
    if (root.classList.contains('ez-modus-leaving')) return;

    if (reduceMotion) {
      applyModus(modus);
      return;
    }

    root.classList.add('ez-modus-leaving');

    window.setTimeout(function () {
      root.classList.remove('ez-modus-leaving');
      applyModus(modus);
      root.classList.add('ez-modus-entering');

      window.setTimeout(function () {
        root.classList.remove('ez-modus-entering');
      }, ENTER_MS);
    }, LEAVE_MS);
  }

  document.addEventListener('click', function (event) {
    if (!event.target || !event.target.closest) return;

    /* Schwester-Collection: normaler Link (nur Desktop). Zielwelt vorher merken. */
    var sister = event.target.closest('[data-ez-sister]');
    if (sister) {
      var target = sister.getAttribute('data-ez-target');
      if (isValid(target)) remember(target);
      return;
    }

    var pill = event.target.closest('[data-ez-switch]');
    if (!pill) return;

    event.preventDefault();
    switchInPlace(pill.getAttribute('data-ez-switch'));
  });

  function init() {
    var modus = root.getAttribute('data-ez-modus');
    if (isValid(modus)) syncDrawer(modus);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
